import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// material-ui
import { styled } from '@mui/material/styles'
import { shouldForwardProp } from '@mui/system'

import { Chip, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'

const ResultStyle = styled(List, { shouldForwardProp })(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: 5,
  boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
  marginLeft: 16,
  maxHeight: 245,
  overflowY: 'auto',
  position: 'absolute',
  width: 434,
  zIndex: 10,
  [theme.breakpoints.down('lg')]: {
    width: 250,
  },
  [theme.breakpoints.down('md')]: {
    width: '87%',
    marginLeft: 4,
    background: '#fff',
  },
}))

const ResultItemStyle = styled(ListItemButton, { shouldForwardProp })(({ theme }) => ({
  borderBottom: `1px dashed ${theme.palette.primary.light}`,
  '&:last-child': {
    borderBottom: 0,
  },
}))

// ==============================|| Results Item ||============================== //

const Results = ({ searchResults, setState }) => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()

  return (
    <ResultStyle component="nav" aria-labelledby="nested-list-subheader">
      {searchResults?.length ? (
        searchResults.map((project) => (
          <ResultItemStyle
            key={project.id}
            onMouseDown={(e) => {
              navigate(`/project/${project.id}`)
              setState({ showResults: false })
            }}
          >
            <ListItemIcon>
              <HomeOutlinedIcon sx={{ fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText primary={project.display_name} />
            {project?.archive_date && <Chip label={t('archived')} variant="outlined" size="small" />}
          </ResultItemStyle>
        ))
      ) : (
        <ResultItemStyle disabled>
          <ListItemIcon>
            <HomeOutlinedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary={t('noProjectsFound')} />
        </ResultItemStyle>
      )}
    </ResultStyle>
  )
}

Results.propTypes = {
  searchResults: PropTypes.array,
  setState: PropTypes.func,
}

export default Results
